import React from 'react';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import { styles } from './notificationSettingsStyles';

const NotificationCardHeader = ({ icon, title, description }) => (
  <CBMediaQuery>
    {screenSize => (
      <div style={getStyle(screenSize, styles, 'header')}>
        <div style={getStyle(screenSize, styles, 'iconBox')}>
          <i className={icon} style={styles.default.icon} />
        </div>
        <div>
          <h2 style={getStyle(screenSize, styles, 'title')}>{title}</h2>
          {description && <p style={getStyle(screenSize, styles, 'description')}>{description}</p>}
        </div>
      </div>
    )}
  </CBMediaQuery>
);

export default NotificationCardHeader;
